import {gql} from "@apollo/client";

export default gql`
  fragment WebformFragment on WebformParagraph {
    id
    url
  }
`;
